import React, { useEffect } from "react";
import AnalyticsIcon from "../assets/images/analyticsIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { getFunds } from "../store/Slice/FundsSlice";

const Funds = () => {
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.funds);

  useEffect(() => {
    dispatch(getFunds(userId));
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 w-full max-w-[1200px] mx-auto">
      {/* Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition">
          Add Funds
        </button>
        <button className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition">
          Withdraw
        </button>
      </div>

      {/* Funds Details */}
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Equity Container */}
        <div className="flex-1 bg-white rounded-lg shadow p-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-gray-800">Equity</h3>
            <div className="flex gap-4">
              {["View statement", "Help"].map((label, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-1 cursor-pointer text-gray-700 text-sm"
                >
                  <img src={AnalyticsIcon} alt={label} className="w-5 h-5" />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Details Card */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Segment 1 */}
            <div className="space-y-2">
              <p className="text-gray-500">Available Margin</p>
              <p className="font-bold text-gray-800">
                {data[0]?.availableMargin}
              </p>

              <p className="text-gray-500">Used Margin</p>
              <p className="text-gray-800">{data[0]?.usedMargin}</p>

              <p className="text-gray-500">Available Cash</p>
              <p className="text-gray-800">{data[0]?.availableCash}</p>
            </div>

            {/* Segment 2 */}
            <div className="space-y-2">
              <p className="text-gray-500">Opening Balance</p>
              <p className="text-gray-800">{data[0]?.openingBalance}</p>

              <p className="text-gray-500">Paying</p>
              <p className="text-gray-800">{data[0]?.paying}</p>

              <p className="text-gray-500">Payout</p>
              <p className="text-gray-800">{data[0]?.payout}</p>

              <p className="text-gray-500">SPAN</p>
              <p className="text-gray-800">{data[0]?.span}</p>

              <p className="text-gray-500">Delivery Margin</p>
              <p className="text-gray-800">{data[0]?.delieryMargin}</p>

              <p className="text-gray-500">Exposure</p>
              <p className="text-gray-800">{data[0]?.exposure}</p>
            </div>

            {/* Segment 3 */}
            <div className="space-y-2">
              <p className="text-gray-500">Opening Balance</p>
              <p className="text-gray-800">{data[0]?.openingBalance}</p>

              <p className="text-gray-500">Paying</p>
              <p className="text-gray-800">{data[0]?.paying}</p>

              <p className="text-gray-500">Payout</p>
              <p className="text-gray-800">{data[0]?.payout}</p>
            </div>
          </div>
        </div>

        {/* Commodity Container */}
        <div className="flex-1 bg-white rounded-lg shadow p-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-gray-800">Commodity</h3>
            <div className="flex gap-4">
              {["View statement", "Help"].map((label, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-1 cursor-pointer text-gray-700 text-sm"
                >
                  <img src={AnalyticsIcon} alt={label} className="w-5 h-5" />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Commodity Card */}
          <div className="flex flex-col items-center justify-center gap-4 border border-gray-200 rounded-lg p-6">
            <p className="text-gray-500">You don't have any commodity yet</p>
            <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition">
              Activate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Funds;
